import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from "@angular/router";
import { BulkRenewalFlowService } from "../../service/bulk-renewal-flow.service";
import { Pipe, PipeTransform } from "@angular/core";

@Component({
  selector: "app-bulk-renewal-flow",
  templateUrl: "./bulk-renewal-flow.component.html",
  styleUrls: ["./bulk-renewal-flow.component.scss"],
  providers: [BulkRenewalFlowService]
})
export class BulkRenewalFlowComponent implements OnInit {

  public bulkRenewalForm: FormGroup;

  private permissoes = [];
  private users = [];
  private userList = [];
  private usersfilteredList = [];
  private bulkRenewalFlows;

  private user = {
    userName: "",
    userID: ""
  };

  private lastBulkRenewalFlow = {
    Nivel: 0,
    ID: "",
    Usuario: ""
  };

  constructor(fb: FormBuilder, private bulkRenewalFlowService: BulkRenewalFlowService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
    this.bulkRenewalForm = fb.group({
      Nivel: ["", Validators.required],
      UserID: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.getUsersList();
    this.getBulkRenewalFlows();
    this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
  }

  // Controles de Filtro de Usuário
  selectUser(user) {
    this.user = user;
    this.bulkRenewalForm.controls.UserID.setValue(this.user.userID);
    this.usersfilteredList = [];
  }

  getUsersList() {
    this.bulkRenewalFlowService.getUsers().subscribe(result => {
      this.users = result.Result;
      this.users.forEach(user => {
        this.userList.push({
          userName: user.Nome + " (" + user.Login + ")",
          userID: user.ID
        });
      });
    });
  }

  filterUsers(event) {
    var query = event.target.value;
    if (query !== "") {
      this.usersfilteredList = this.userList.filter(
        function (el) {
          var user = el.userName ? el.userName.toLowerCase() : "";
          return user.indexOf(query.toLowerCase()) > -1;
        }.bind(this)
      );
    } else{
      this.usersfilteredList = [];
    }
  }

  // Controles de Listagem, Inserção e Remoção de Fluxo.
  getBulkRenewalFlows() {
    this.bulkRenewalFlowService.getBulkRenewalFlows().subscribe(result => {
        if (result.Result) {
          this.bulkRenewalFlows = result.Result;
          if (this.bulkRenewalFlows.length > 0) {
            this.lastBulkRenewalFlow = this.bulkRenewalFlows[this.bulkRenewalFlows.length - 1];
            this.bulkRenewalForm.controls.Nivel.setValue(this.lastBulkRenewalFlow.Nivel + 1);
          } else {
            this.lastBulkRenewalFlow.Nivel = 0;
          }
        } else {
          this.flashMessagesService.show(result.Errors, { cssClass: "alert-danger", timeout: 6000 });
        }
        this.bulkRenewalForm.controls.Nivel.setValue(this.lastBulkRenewalFlow.Nivel + 1);
      },
      error => {
        console.log(error);
      }
    );
  }

  addBulkRenewalFlow() {
    this.bulkRenewalFlowService.insertBulkRenewalFlow(this.bulkRenewalForm.value).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show('Nível cadastrado com sucesso.', { cssClass: 'alert-success', timeout: 6000 });
        this.getBulkRenewalFlows();
        this.user = {
          userName: "",
          userID: ""
        };
        this.bulkRenewalForm.controls.UserID.reset();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  deleteBulkRenewalFlow() {
    this.bulkRenewalFlowService.deleteBulkRenewalFlow(this.lastBulkRenewalFlow.ID).subscribe(result => {
      if (result.Success) {
        this.flashMessagesService.show("Nível excluído com sucesso.", { cssClass: "alert-success", timeout: 6000});
        this.getBulkRenewalFlows();
        //this.bulkRenewalForm.controls.Usuario.reset();
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: "alert-danger", timeout: 6000 });
      }
    },
    error => {
      console.log(error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/bulk-renewal-flow/component/bulk-renewal-flow/bulk-renewal-flow.component.ts